import { Box, Button, SxProps, Theme, useTheme } from "@mui/material";
import { Minus, Plus } from "../../icons";

type InputQuantityProps = {
  isAvailable?: boolean;
  quantity: number;
  available: number;
  setQuantity: (qty: number) => void;
};

const getStyle = (theme: Theme) => {
  const content: SxProps<Theme> = {
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
    borderRadius: 2,
    overflow: "hidden",
    backgroundColor: theme.palette.common.white,
    boxShadow: `0px 0px 0px 1px ${theme.palette.customColor?.dark}`,
  };
  const button: SxProps<Theme> = {
    padding: 2.5,
    minWidth: 40,
    borderRadius: "0px !important",
    backgroundColor: theme.palette.common.white,
  };
  return { content, button };
};

export const InputQuantity = ({
  isAvailable,
  quantity,
  available,
  setQuantity,
}: InputQuantityProps) => {
  const theme = useTheme();
  const styles = getStyle(theme);

  const onMinusQuantity = () => {
    if (quantity > 1) setQuantity(quantity - 1);
  };

  const onPlusQuantity = () => {
    if (quantity < available) setQuantity(quantity + 1);
  };

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const numericValue = parseInt(value);

    if (value === "") {
      setQuantity(0);
      return;
    }

    if (isNaN(numericValue)) return;

    if (numericValue > available) {
      setQuantity(available);
    } else if (numericValue < 1) {
      setQuantity(1);
    } else {
      setQuantity(numericValue);
    }
  };

  return (
    <Box sx={styles.content}>
      <Button
        disabled={isAvailable}
        onClick={onMinusQuantity}
        TouchRippleProps={{
          style: {
            color: theme.palette.common.black,
          },
        }}
        sx={styles.button}
      >
        <Minus sx={{ width: 16, height: 16 }} />
      </Button>
      <input
        disabled={isAvailable}
        type="text"
        style={{
          backgroundColor: theme.palette.brand?.main,
          textAlign: "center",
          fontSize: 15,
          maxWidth: 60,
          color: theme.palette.secondary[500],
          outline: "none",
          border: "none",
        }}
        onChange={onInputChange}
        value={quantity}
      />
      <Button
        disabled={isAvailable}
        onClick={onPlusQuantity}
        TouchRippleProps={{
          style: {
            color: theme.palette.common.black,
          },
        }}
        sx={styles.button}
      >
        <Plus sx={{ width: 16, height: 16 }} />
      </Button>
    </Box>
  );
};
